<template>
  <div class="general-frame">
    <div class="general-neick">
      <div class="general-search-bar">
        <div class="customButton" v-for="(item,index) in dateQuery" :key="index" @click="switchSelection(index)"
          :class="butonStart === index ? 'border-end':''">{{item.name}}</div>
        <el-date-picker v-model="queryDate" :type="type" :value-format="valueFormat" @change="getList()" :picker-options="pickerOptions">
        </el-date-picker>
        <el-button type="primary" class="elm-but"
          @click="reset"
          style="margin-left: 8px;">重置</el-button>
        <el-button type="success" icon="el-icon-download" @click="downloadReport()">导出</el-button>
      </div>
      <div>
        <table class="surface">
          <thead>
            <tr>
              <th>厕所名称</th>
              <th>厕所类型</th>
              <th>空气质量</th>
              <th>厕所能耗</th>
              <th>人流量</th>
              <th>用水量</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in data" :key="index">
              <td>{{item.siteType}}</td>
              <td>{{item.siteName}}</td>
              <td>{{item.alarmTitle}}</td>
              <td>{{item.typeName}}</td>
              <td>{{item.realName}}</td>
              <td>{{item.ticketStatus}}</td>
            </tr>
          </tbody>
          <noData :data="data" />
        </table>
        <el-pagination background style="text-align: center;margin-top:15px" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page.sync="pageNum " layout="prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </div>
  </div>
</template>


<script>
import noData  from "@/components/html/noData";
  export default {
    components: {
      noData
    },
    data() {
      return {
        pageSize: 10, //每页10条
        pageNum: 1, //当前页码
        total: 0,
        data: null,
        queryDate: "",  //日期请求参数
        type: "year",
        valueFormat: "yyyy",
        dateQuery: [{ name: "年", },{ name: "月", },{ name: "日", },],
        butonStart: 0, //日期按钮
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 8.64e6; //如
          },
        },
      };
    },
    methods: {
      getList() {
        this.get("operation/report/inspectionList", {
          queryDate: this.queryDate,
          pageSize: this.pageSize,
          pageNum: this.pageNum,
        }).then((res) => {
          this.data = res.data.rows;
          this.total = res.data.total;
        });
      },


      //日期按钮点击切换
      switchSelection(index) {
        this.butonStart = index;
        this.queryDate = null;
        if (this.butonStart == 0) {
          this.type = "year"
          this.valueFormat = "yyyy"
          this.queryDate = new Date().getFullYear().toString();
        } else if (this.butonStart == 1) {
          this.type = "month"
          this.valueFormat = "yyyy-MM"
          this.queryDate = this.global.date('month')
        } else {
          this.type = "date"
          this.valueFormat = "yyyy-MM-dd"
          this.queryDate = this.global.date('date')
        }
        this.getList();
      },


      // 导出报表
      downloadReport() {
        if (this.queryDate != "") {
          this.get("operation/report/inspectionExport", {
            queryDate: this.queryDate
          }).then((res) => {
            this.global.download(res.data.msg)
          });
        } else {
          this.$message({
            message: '请先选择报表导出日期',
            type: 'warning'
          });
        }
      },

      //重置
      reset() {
        this.butonStart = 0;
        this.type = "year",
        this.valueFormat = "yyyy",
        this.queryDate = new Date().getFullYear().toString();
        this.getList();
      },

      //pageNum  改变时会触发
      handleCurrentChange(pageNum) {
        this.pageNum = pageNum;
        this.getList(); //调用终端数据接口
      },

      //pageSize改变时会触发
      handleSizeChange(pageSize) {
        this.pageSize = pageSize;
      },
    },
    mounted() {
      this.queryDate = new Date().getFullYear().toString();
      this.getList();
    },
  };
</script>




// WEBPACK FOOTER //
// src/pages/menu/statisticalReport/inspection.vue